<div class="groupInvite-container ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader class="subheader" [hasContent]="false"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="group-content">
      <div class="group-invites">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="hypersoft-user-plus.svg"></div>
        </div>
        <div class="group-invite-content">
          <div class="group-invite-info-item">
            <h2 class="title" langkey="phRemoteOrder_Share_Title"></h2>
            <span class="text content-container--subfont" langkey="phRemoteOrder_Share_SubText"></span>
          </div>
        </div>
        <div class="botton-wrapper">
          <div class="ya-webshop-button-container">
            <ng-container *ngIf="groupIsFull$| async; let groupIsFull; then deactiveButton else activeButton">
            </ng-container>
            <ng-template #deactiveButton>
              <span (click)="OpenWarningGroupIsFull()">
                <button mat-flat-button disabled><span langkey="phRemoteOrder_share_Link"></span></button>
              </span>
            </ng-template>
            <ng-template #activeButton>
              <button mat-flat-button (click)="ShareLink()"><span langkey="phRemoteOrder_share_Link"></span></button>
            </ng-template>
          </div>
        </div>
      </div>
      <ng-container *ngIf="shownavigatetomenu">
        <div class="group-navigatetomenu">
          <div class="botton-wrapper">
            <div class="ya-webshop-button-container btn-outline">
              <button mat-flat-button class="navigate-to-menu-button" (click)="confirmAndNavigate()">
                <span>{{OrderButtonLabel()}}</span>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>